"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _createIcon = _interopRequireDefault(require("../Icon/createIcon"));

var _default = (0, _createIcon.default)( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M6.445 12.668a.9.9 0 00-1.303 1.242l3.573 3.745a.9.9 0 001.335-.036l8.591-10.037a.9.9 0 00-1.367-1.17l-7.656 8.944a.4.4 0 01-.593.016l-2.58-2.704z"
})), "0 0 24 24", "Check");

exports.default = _default;